import { render, staticRenderFns } from "./ErrorContent.vue?vue&type=template&id=f1ae557c&"
import script from "./ErrorContent.vue?vue&type=script&lang=js&"
export * from "./ErrorContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports